import React, { FunctionComponent, useMemo } from 'react';
import { useTheme } from '@material-ui/core';
import variantDataExtractor from '../../../../../../gqlCommon/service/variantDataExtractor';
import SectionLoader from '../../../../../../common/components/loaders/SectionLoader';
import SpecPackList from './SpecPackList';
import SpecificationsAndFeaturesContainer from '../../specificationsAndFeatures/SpecificationsAndFeaturesContainer';
import { ISpcTheme } from '../../../../../../common/theme/ISpcTheme';
import MarketingCategoriesTabs from '../../../../../../gqlCommon/components/marketingCategoriesTabs/MarketingCategoriesTabs';
import useFilterTabs from '../../../../../../gqlCommon/hooks/useFilterTabs';
import { GetSimpleSpecPackTrimLevel_specPacks } from '../../../../../../trimLevels/graphql/queries/__generated__/GetSimpleSpecPackTrimLevel';

interface IModelListContainerProps {
  specPacks: GetSimpleSpecPackTrimLevel_specPacks[];
  selectedVariantId: string;
  changeVariant: (variantId: string) => void;
  isLoadingVariants: boolean;
  modelName?: string;
}

const SpecPackListContainer: FunctionComponent<IModelListContainerProps> = ({
  specPacks,
  selectedVariantId,
  changeVariant,
  isLoadingVariants,
  modelName,
}) => {
  const selectedSpecPackData = useMemo(
    () => variantDataExtractor.getSpecPackByVariantId(specPacks, selectedVariantId),
    [selectedVariantId, specPacks],
  );
  const {
    spc: {
      trimLevels: { isFilterTabs },
    },
  } = useTheme<ISpcTheme>();
  const { currentFilter, onFilterTabNavigate, marketingCategories, filteredDataTabs } = useFilterTabs(specPacks);

  if (isLoadingVariants && !specPacks.length) {
    return <SectionLoader />;
  }
  const car = selectedSpecPackData?.carConfig?.car;

  return (
    <>
      {isFilterTabs && currentFilter && marketingCategories.length > 1 && (
        <MarketingCategoriesTabs {...{ onFilterTabNavigate, marketingCategories, currentTab: currentFilter }} />
      )}
      <SpecPackList
        specPacks={isFilterTabs ? (filteredDataTabs as GetSimpleSpecPackTrimLevel_specPacks[]) : specPacks}
        selectedVariantId={selectedVariantId}
        selectVariantId={changeVariant}
        modelName={modelName}
        detailsSlot={
          <SpecificationsAndFeaturesContainer
            oemCode={car?.model?.attributes?.oemcode}
            keyFeatures={car?.keyFeatures}
            specDescription={car?.attributes?.specDescription}
          />
        }
      />
    </>
  );
};

export default SpecPackListContainer;
